export enum USER_TYPE {
  TENANTS = 'TENANT',
  CLIENTS = 'CLIENT',
  TAX_PREPARER = 'TAX_PREPARER',
  ACCOUNTANT = 'ACCOUNTANT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  TENANT_ADMIN = 'TENANT_ADMIN',
  VIEWER = 'VIEWER',
}

export type IUserType = USER_TYPE.CLIENTS | USER_TYPE.TENANTS;
